/**
 * Hat Builder Image Configuration
 * 
 * EASY EDITING INSTRUCTIONS:
 * 1. Upload new image to Shopify Files (Settings → Files)
 * 2. Copy the full URL including the ?v= version parameter
 * 3. Update the URL below using the EXACT KEY from the lists below
 * 4. Save and hard refresh (Ctrl+Shift+R) - changes are live immediately!
 * 
 * IMPORTANT: Keys must match exactly what's shown below (case-sensitive)
 * 
 * CROWN KEYS:
 *   association, brick, brick-cross, brick-initial, cattleman, cattleman-low,
 *   cattleman-punched, cattleman-wide, clint, diamond-top, gambler, gus, heart,
 *   horseshoe, luke, minick, minick-heart, open, puncher, ranch, rose, round-top, square-top
 * 
 * BRIM FRONT KEYS:
 *   flat, pointed, round, square, wide, extra-wide, buckaroo
 *   (NOTE: Use "square" not "square-6", "wide" not "wide-8", etc.)
 * 
 * BRIM SHAPE KEYS:
 *   flat, low, george, relaxed-taco, half-taco, taco, retro, come-go, buckaroo
 *   (NOTE: Use "come-go" not "come-and-go")
 * 
 * PERFORMANCE TIP: Use WebP format for smaller file sizes and faster loading
 * 
 * Last Updated: 2026-04-28 — brim shape "flat" image swapped to buckaroo_brim.webp
 */

window.CROWN_IMAGE_CONFIG = {
  "crowns": {
    "association": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_association.webp",
    "brick": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_brick.webp",
    "brick-cross": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_brick-cross.webp",
    "brick-initial": "https://thecowlot.com/cdn/shop/files/brick_with_initial_profile.webp",
    "cattleman": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_cattleman.web",
    "cattleman-low": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_low-cattleman.webp",
    "cattleman-punched": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_punched-cattleman.webp",
    "cattleman-wide": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_wide-cattleman.webp2",
    "clint": "https://thecowlot.com/cdn/shop/files/948C76F9-C470-4B1B-909E-B0D6E6A87E42.jpg",
    "diamond-top": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_diamond-top.webp",
    "gambler": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_gambler.webp",
    "gus": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_gus.webp",
    "heart": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_heart.jpg",
    "horseshoe": "https://thecowlot.com/cdn/shop/files/58538_additional_side.webp",
    "luke": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_luke.jpg",
    "minick": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_minick.webp",
    "minick-heart": "https://thecowlot.com/cdn/shop/files/image000000_1.jpg",
    "open": "https://thecowlot.com/cdn/shop/files/IMG_5683_cf22e9ca-2a8c-45dd-9ba0-b4bf8307f9a6.jpg",
    "puncher": "https://thecowlot.com/cdn/shop/files/puncher_profile_2.webp",
    "ranch": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_ranch.webp",
    "rose": "https://thecowlot.com/cdn/shop/files/Screenshot_20250923_160100_Samsung_Internet_1.jpg",
    "round-top": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/crowns_round-top.webp",
    "square-top": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/Crowns_Squaretop.webp"
  },
  "brimFronts": {
    "flat": "https://thecowlot.com/cdn/shop/files/buckaroo_brim.webp?v=1764977311&width=1000",
    "pointed": "https://thecowlot.com/cdn/shop/files/pointed_relaxed_taco.webp",
    "round": "https://thecowlot.com/cdn/shop/files/57046_front.webp",
    "square": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/square6.webp?v=1776403230",
    "wide": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/wide8.webp?v=1776403328",
    "extra-wide": "https://cdn.shopify.com/s/files/1/0478/1673/6918/files/extrawide10.webp?v=1776403375",
    "buckaroo": "https://thecowlot.com/cdn/shop/files/57757_front.webp"
  },
  "brimShapes": {
    "flat": "https://thecowlot.com/cdn/shop/files/buckaroo_brim.webp?v=1764977311&width=1000",
    "low": "https://thecowlot.com/cdn/shop/files/round_low_front.webp",
    "george": "https://thecowlot.com/cdn/shop/files/square_george_front.webp",
    "relaxed-taco": "https://thecowlot.com/cdn/shop/files/square_rexlaxed_taco.webp",
    "half-taco": "https://thecowlot.com/cdn/shop/files/square_half_taco_front.webp",
    "taco": "https://thecowlot.com/cdn/shop/files/57516_front.webp",
    "retro": "https://thecowlot.com/cdn/shop/files/56890_front.webp",
    "come-go": "https://thecowlot.com/cdn/shop/files/wide_come_and_go_front.webp",
    "buckaroo": "https://thecowlot.com/cdn/shop/files/57757_side_profile.webp"
  }
};
